const site = site || {};
site.Animation = (() => {
    // Functions

    // const functionName = () => {
    //
    // };

    const registerGsap = () => {
        // GLOBAL ANIMATION SETTINGS
        // gsap.registerPlugin(MotionPathPlugin);
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, MotionPathPlugin);
        ScrollTrigger.config({
            limitCallbacks: true,
            ignoreMobileResize: true,
        })
    }
    
    const smoothScrolling = (mediaQueries) => {
        const smoother = ScrollSmoother.create({
            wrapper : "#smooth-wrapper",
            content: "#smooth-content",
            smooth: 2,
            // effects: true
            // normalizeScroll: true
        });
        smoother.effects(".js-smooth-speed [data-speed]");
        if (!window.matchMedia('(hover: none)').matches) {
            smoother.effects(".parallax-image img", { speed: "auto" });
        }
    }

    const speedCharacteristics = () => {
        // gsap.to(".parallax-image", {
        //     scrollTrigger: ".parallax-image",
        // });
    
        // MAIN NAV ITEMS - SCROLL SPEED
        gsap.to(".js-manual-speed [data-speed]", {
            y: (i, el) => (1 - parseFloat(el.getAttribute("data-speed"))) * ScrollTrigger.maxScroll(window) ,
            ease: "none",
            scrollTrigger: {
                start: 0,
                end: "max",
                invalidateOnRefresh: true,
                scrub: 0
            }
        });
        if (window.matchMedia('(hover: none)').matches) {
            const smoothSpeedObjects = document.querySelectorAll('.js-smooth-speed [data-speed]');
            smoothSpeedObjects.forEach((object) => {
                object.dataset.speed = 1;
            });
        }
    }

    const pinnedNavItems = (mediaQueries) => {
        const pinnedItems = document.querySelectorAll('.js-pinned-nav-item');
        pinnedItems.forEach((item) => {
            if (mediaQueries.xlDown.matches) {
                item.dataset.speed = .5;
                
            } else {
                item.dataset.speed = 0;
            }
        })
    }

    const skewElement = () => {
        if (document.querySelector('.js-skew-element')) {
            //----------------------------------------------------------------------------//
            // SKEW AN ELEMENT BASED ON THE USER'S SCROLL VELOCITY
            //----------------------------------------------------------------------------//
            let proxy = { skew: 0 },
                skewSetter = gsap.quickSetter(".js-skew-element", "skewY", "deg"), 
                clamp = gsap.utils.clamp(-10, 10); // don't let the skew go beyond 20 degrees. 
    
            ScrollTrigger.create({
                onUpdate: (self) => {
                    let skew = clamp(self.getVelocity() / -300);
                    if (Math.abs(skew) > Math.abs(proxy.skew)) {
                        proxy.skew = skew;
                        gsap.to(proxy, {
                            skew: 0,
                            duration: 0.8,
                            ease: "none",
                            overwrite: true,
                            onUpdate: () => skewSetter(proxy.skew)
                        });
                    }
                }
            });
    
            gsap.set(".js-skew-element", {
                transformOrigin: "right center",
                force3D: true
            });
        }
        
    }


    const slideUp = () => {
        const slideUpItems = gsap.utils.toArray('.js-slide-up');
        if (slideUpItems) {
            slideUpItems.forEach((item) => {
                gsap.from(item, {
                    y: 50,
                    opacity: 0,
                    ease: 'back.out(1)',
                    duration: 1.25,
                    scrollTrigger: {
                        trigger: item,
                        start: "+=00 bottom",
                    },
                });
            });
        }
    }

    const staggerItems = () => {
        const staggerContainers = gsap.utils.toArray('.js-stagger-items-container');
        if (staggerContainers) {
            staggerContainers.forEach((container) => {
                const staggerItem = container.querySelectorAll('.js-stagger-item');
    
                gsap.from(staggerItem, {
                    opacity: 0,
                    y: 100,
                    ease: "back.inOut(4)",
                    duration: 1.25,
                    stagger: .2, 
                    scrollTrigger: {
                        trigger: container,
                        start: '+=50 bottom',
                    }
                });
            })
        }
    }

    const slideLeft = () => {
        const slideLeftObjects = gsap.utils.toArray('.js-slide-left');
        if (slideLeftObjects) {
            slideLeftObjects.forEach((object) => {
                gsap.from(object, {
                    opacity: 0,
                    x: 100,
                    ease: "back.inOut(1)",
                    duration: 1.25,
                    scrollTrigger: {
                        trigger: object,
                        start: '+=0 bottom'
                    }
                });
            })
        }
    }
    
    const slideRight = () => {
        const slideLeftObjects = gsap.utils.toArray('.js-slide-right');
        if (slideLeftObjects) {
            slideLeftObjects.forEach((object) => {
                gsap.from(object, {
                    opacity: 0,
                    x: -100,
                    ease: "back.inOut(1)",
                    duration: 1.25,
                    scrollTrigger: {
                        trigger: object,
                        start: '+=0 bottom'
                    }
                });
            })
        }
    }

    const gradientMesh = () => {
        //----------------------------------------------------------------------------//
        // Random Number Generator (Produces decimal values)
        //----------------------------------------------------------------------------//
        function randomInt(min, max) {
            return Math.random() * (max - min) + min;
        }
        //----------------------------------------------------------------------------//
        // GRADIENT MESH 1 ANIMATION
        //----------------------------------------------------------------------------//
        const gradientMesh1 = gsap.timeline({
            repeat: -1, 
            repeatDelay: 0, 
            yoyo: 0
        });
        //-- Phase 1 -----------------------------------------------------------------//
        gradientMesh1.to(".js-gradient-animated .gradient-blue", {
            x: randomInt(-100, 200),
            y: randomInt(-200, 100),
            rotate: randomInt(5, 9), 
            scale: randomInt(1.5, 2), 
            // opacity: randomInt(.9, 1),
            duration: randomInt(6,8),
            // ease: 'back.out(1.7)', 
        }, 0).addLabel('blue1');
        gradientMesh1.to(".js-gradient-animated .gradient-orange", {
            x: randomInt(100, 200), 
            y: randomInt(-50, 50),
            rotate: randomInt(-9, 0), 
            scale: randomInt(1, 1.25), 
            // opacity: randomInt(.9, 1),
            duration: randomInt(6,8),
            // ease: 'back.out(1.7)', 
        }, 0).addLabel('orange1');
        gradientMesh1.to(".js-gradient-animated .gradient-pink", {
            x: randomInt(-200, 100), 
            y: randomInt(-50, 50),
            rotate: randomInt(-12, 6), 
            scale: randomInt(1, 1.5),
            // opacity: randomInt(.9, 1),
            duration: randomInt(6,8),
            // ease: 'back.out(1.7)', 
        }, 0).addLabel('pink1');
        //-- Phase 2 -----------------------------------------------------------------//
        gradientMesh1.to(".js-gradient-animated .gradient-blue", {
            x: randomInt(-200, -50),
            y: randomInt(-100, 50),
            rotate: randomInt(-17, -12), 
            scale: randomInt(2, 3), 
            // opacity: randomInt(.9, 1),
            duration: randomInt(6,8),
            // ease: 'back.out(1.7)', 
        }, 'blue1').addLabel('blue2');
        gradientMesh1.to(".js-gradient-animated .gradient-orange", {
            x: randomInt(-300, 0), 
            y: randomInt(20, 75),
            rotate: randomInt(8, 11), 
            scale: randomInt(1, 1.25), 
            // opacity: randomInt(.9, 1),
            duration: 6,
            // ease: 'back.out(1.7)', 
        }, 'orange1').addLabel('orange2');
        gradientMesh1.to(".js-gradient-animated .gradient-pink", {
            x: randomInt(-100, 0), 
            y: randomInt(-50, 150),
            rotate: randomInt(-6, 6), 
            scale: randomInt(1, 1.5),
            // opacity: randomInt(.9, 1),
            duration: 6,
            // ease: 'back.out(1.7)', 
        }, 'pink1').addLabel('pink2');
        //-- Phase 3 -----------------------------------------------------------------//
        gradientMesh1.to(".js-gradient-animated .gradient-blue", {
            x: 0,
            y: 0,
            rotate: 0, 
            scale: 1, 
            opacity: 1,
            // ease: 'back.out(1.7)', 
            duration: randomInt(7,8),
        }, "blue2");
        gradientMesh1.to(".js-gradient-animated .gradient-orange", {
            x: 0,
            y: 0,
            rotate: 0, 
            scale: 1, 
            opacity: 1,
            // ease: 'back.out(1.7)', 
            duration: randomInt(6,8),
        }, "orange2");
        gradientMesh1.to(".js-gradient-animated .gradient-pink", {
            x: 0,
            y: 0,
            rotate: 0,
            scale: 1, 
            opacity: 1,
            // ease: 'back.out(1.7)', 
            duration: randomInt(6,8),
        }, "pink2");
    }


    //----------------------------------------------------------------------------//
    //  ORBIT ANIMATION
    //----------------------------------------------------------------------------//
    const staticOrbit = () => {

        MotionPathPlugin.convertToPath("#orbit-path");
        MotionPathPlugin.convertToPath("#orbit-path-2");
        MotionPathPlugin.convertToPath("#orbit-path-3");
        
        const orbits = document.querySelectorAll('.js-static-orbit')
        
        if (orbits) {
            orbits.forEach((orbit, index) => {
                const orbitOne = orbit.querySelector('#orbit-path');
                const orbitTwo = orbit.querySelector('#orbit-path-2');
                const orbitThree = orbit.querySelector('#orbit-path-3');

                const vesselOne = orbit.querySelector('#orbiter-vessel-1');
                const vesselTwo = orbit.querySelector('#orbiter-vessel-2');
                const vesselThree = orbit.querySelector('#orbiter-vessel-3');
                
                const vessel1 = gsap.to(vesselOne, {
                    repeat: -1,
                    ease: "linear",
                    duration: 70,
                    motionPath: {
                        path: orbitOne,
                        align: orbitOne,
                        alignOrigin: [0.5, 0.5],
                        autoRotate: true,
                        start: -.75,
                        // transformOrigin: '50% 50%',
                        xPercent: -50, 
                        yPercent: -50,
                    },
                });
                const vessel2 = gsap.to(vesselTwo, {
                    repeat: -1,
                    ease: "linear",
                    duration: 35,
                    motionPath: {
                        path: orbitTwo,
                        align: orbitTwo,
                        alignOrigin: [0.5, 0.5],
                        autoRotate: true,
                        start: 0,
                        // transformOrigin: '50% 50%',
                        xPercent: -50, 
                        yPercent: -50,
                    },
                });
                const vessel3 = gsap.to(vesselThree, {
                    repeat: -1,
                    ease: "linear",
                    duration: 105,
                    motionPath: {
                        path: orbitThree,
                        align: orbitThree,
                        alignOrigin: [0.5, 0.5],
                        autoRotate: true,
                        start: -.12,
                        // transformOrigin: '50% 50%',
                        xPercent: -50, 
                        yPercent: -50,
                    },
                });

                const resizeHandler = () => {
                    vessel1.invalidate();
                    vessel2.invalidate();
                    vessel3.invalidate();
                    vessel1.play();
                    vessel2.play();
                    vessel3.play();
                };
                  
                const timer = gsap.delayedCall(0.2, resizeHandler).pause();
                window.addEventListener("resize", (event) => {
                    // animateContent();
                    // animateOrbit()
                    ScrollTrigger.refresh();
                    timer.restart(true);
                    vessel1.pause();
                    vessel2.pause();
                    vessel3.pause();
                });

            })

        }
    }



    // Return
    return {
        registerGsap : registerGsap,
        smoothScrolling : smoothScrolling,
        speedCharacteristics : speedCharacteristics,
        pinnedNavItems : pinnedNavItems,
        gradientMesh : gradientMesh,
        skewElement : skewElement,
        slideUp : slideUp,
        staggerItems : staggerItems,
        slideLeft : slideLeft,
        slideRight : slideRight,
        staticOrbit : staticOrbit
    };
})();